module.exports = __webpack_public_path__ + "YT.png?6a918cf33cfa2870188c0fd7cafff0fe";